import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { GenericHorizontalListViewImpl } from './genericlistview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { GenericHorizontalListCSSStyleImpl } from './genericlistcss';
import { BaseContext } from '../../../../utils/basecontext';
// import * as $ from "jquery";

export interface GenericHorizontalListComponentProps extends UIComponentProps
{
    title: string;
    length: number;
    titleCSSStyle: object;
    arrowMarginTop: string;
    gutterMargin: string;
    arrowsSizeType: string;
    arrowsPaddingType: string;
    children: any;
    arrowsType?:string;
    isLoadMoreRequired: boolean;
    onScrollEnd(): void;
}

export interface GenericHorizontalListComponentState extends UIComponentState
{
    isLeftArrowEnabled: boolean;
    isRightArrowEnabled: boolean;
}

export interface GenericHorizontalListComponentHandler extends UIComponentHandler
{
    onScroll(): void;
}

export class GenericHorizontalListComponent extends UIComponentImpl<GenericHorizontalListComponentProps, GenericHorizontalListComponentState, UIDataModel> 
    implements GenericHorizontalListComponentHandler
{
    constructor(props: GenericHorizontalListComponentProps)
    {
        super(props);

        this.state = {isLeftArrowEnabled: true , isRightArrowEnabled:true};
    }

    componentDidMount()
    {
        // $(window).resize(()=>this.changeScrollButtonVisibiltyIfReq());

        // this.changeScrollButtonVisibiltyIfReq();
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new GenericHorizontalListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new GenericHorizontalListCSSStyleImpl(applicationContext);
    }

    componentWillReceiveProps(nextProps: GenericHorizontalListComponentProps)
    {
        this.setState({isLeftArrowEnabled: true , isRightArrowEnabled:true});
    }

    onScroll(): void 
    {
        this.changeScrollButtonVisibiltyIfReq();
    }

    private changeScrollButtonVisibiltyIfReq()
    {
        let listRef = (this.getView() as GenericHorizontalListViewImpl).getListRef();

        if(listRef)
        {
            console.log("changeScrollButtonVisibiltyIfReq() invoked");
            let isLeftArrowEnabled = this.state.isLeftArrowEnabled;
                isLeftArrowEnabled = listRef.scrollLeft > 0 ? true : false;
        
                if((listRef.scrollWidth - listRef.clientWidth)>listRef.scrollLeft)
                {
                    this.setState({isLeftArrowEnabled: isLeftArrowEnabled, isRightArrowEnabled: true});
                }else
                {
                    //show right arrow only when loadmore is required else once it reaches end hide right arrow
                    this.setState({isLeftArrowEnabled: isLeftArrowEnabled, 
                        isRightArrowEnabled: this.props.isLoadMoreRequired ? true : false},
                               ()=>{this.props.onScrollEnd();});
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/horizontallist/generichorizontallist/genericlistcomponent.tsx